import * as React from "react";

/**
 * The portal's palette (hiberUiKit settings/colors.scss), for the few EV charging styles that are not a portal
 * component of their own.
 */
export const evColors = {
	navy: "#112363",
	muted: "#676c7b",
	border: "#d9d9d9",
	background: "#f2f3f8",
	error: "#d0021b",
	note: "#fff0c5",
	ok: "#3ecf13"
};

export const evMessageStyles: { [key: string]: React.CSSProperties } = {
	error: {fontSize: 12, lineHeight: "17px", color: evColors.error, marginTop: 6},
	warning: {
		fontSize: 12, lineHeight: "17px", color: evColors.navy, background: evColors.note, padding: "6px 8px",
		borderRadius: 4, marginTop: 6
	},
	hint: {fontSize: 12, lineHeight: "17px", color: evColors.muted, marginTop: 6},
	/**
	 * A short marker beside a value, e.g. a bill entered after the NORA deadline.
	 */
	chip: {
		display: "inline-block", fontSize: 12, lineHeight: "17px", color: evColors.navy, background: evColors.note,
		padding: "1px 6px", borderRadius: 4, whiteSpace: "nowrap"
	}
};
